const STAGES = ["rough-in", "service", "trim", "inspection", "final"];
const LABELS = { "rough-in": "Rough-In", service: "Service", trim: "Trim", inspection: "Inspection", final: "Final" };

export function StageBar({ stage }) {
  const idx = STAGES.indexOf(stage);
  return (
    <div className="flex items-center gap-1.5" data-testid="stage-bar">
      {STAGES.map((s, i) => (
        <div key={s} className="flex-1">
          <div
            className={`h-1.5 rounded-full transition-all ${
              i <= idx ? "bg-cyan-400 shadow-[0_0_8px_rgba(0,229,255,0.5)]" : "bg-slate-700"
            }`}
          />
          <div className={`mt-1.5 text-[10px] font-mono2 uppercase tracking-wide ${i === idx ? "text-cyan-300" : "text-slate-600"}`}>
            {LABELS[s]}
          </div>
        </div>
      ))}
    </div>
  );
}

export function StatusPill({ status }) {
  const map = {
    passed: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
    approved: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
    paid: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
    complete: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
    failed: "bg-rose-500/15 text-rose-300 border-rose-500/30",
    overdue: "bg-rose-500/15 text-rose-300 border-rose-500/30",
    scheduled: "bg-sky-500/15 text-sky-300 border-sky-500/30",
    sent: "bg-sky-500/15 text-sky-300 border-sky-500/30",
    pending: "bg-amber-500/15 text-amber-300 border-amber-500/30",
    requested: "bg-amber-500/15 text-amber-300 border-amber-500/30",
    open: "bg-amber-500/15 text-amber-300 border-amber-500/30",
    confirmed: "bg-sky-500/15 text-sky-300 border-sky-500/30",
    "in_progress": "bg-cyan-500/15 text-cyan-300 border-cyan-500/30",
    submitted: "bg-cyan-500/15 text-cyan-300 border-cyan-500/30",
  };
  const cls = map[status] || "bg-slate-700/40 text-slate-300 border-slate-600/40";
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium capitalize ${cls}`}>
      {String(status || "").replace("_", " ")}
    </span>
  );
}
